__turbopack_context__.v({
  "breadcrumbsRoot": "rwUtXa_breadcrumbsRoot",
  "breadcrumbsSeparator": "rwUtXa_breadcrumbsSeparator",
});
